// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"b29c0355","324":"dc407e03","547":"667373a2","1321":"b3f310d9","2462":"b3f310d9","3276":"b3f310d9","4921":"4c0484c0","6335":"667373a2"}[chunkId] + ".chunk.css";
};